<template>
  <div class="register">
    <h2>Fale Conosco</h2>
    <template v-if="!sent">
      <p>
        Preencha o formulário abaixo para nos enviar uma mensagem.
      </p>
      <form novalidate @submit.prevent="onSubmit">
        <div class="form-group" :class="{'has-danger': errors.has('name')}">
          <input v-validate="'required'" type="text" class="form-control" name="name" placeholder="seu nome" v-model="model.name">
          <div :show="errors.has('name')" class="form-control-feedback">{{ errors.first('name') }}</div>
        </div>
        <div class="form-group" :class="{'has-danger': errors.has('email')}">
          <input v-validate="'required|email'" type="email" class="form-control" name="email" placeholder="seu e-mail" v-model="model.email">
          <div :show="errors.has('email')" class="form-control-feedback">{{ errors.first('email') }}</div>
        </div>
        <div class="form-group" :class="{'has-danger': errors.has('message')}">
          <textarea v-validate="'required'" class="form-control" name="message" placeholder="sua mensagem" v-model="model.message">
          </textarea>
          <div :show="errors.has('message')" class="form-control-feedback">{{ errors.first('message') }}</div>
        </div>
        <div class="text-center">
          <button :disabled="sending" type="submit" class="btn btn-luna">Enviar</button>
        </div>
      </form>
    </template>
    <template v-else>
      <p>
        Obrigado! Em breve você receberá nossa resposta.
      </p>
    </template>
  </div>
</template>

<script>
import portuguese from "vee-validate/dist/locale/pt_BR";

import { API_URL } from "../config";

let { estados } = require("../data/estados-cidades.json");
const estadosDict = estados.reduce((map, state) => {
  map[state.sigla] = state.cidades;
  return map;
}, {});

const options = list => list.map(e => ({ label: e, value: e }));

export default {
  name: "register",
  data: () => ({
    sending: false,
    sent: false,

    model: {
    },

    options: {
    }
  }),
  methods: {
    changePlatform(platform) {
      this.model.platform = platform;
    },
    onSubmit(v) {
      this.sending = true;
      this.$validator
        .validateAll()
        .then(result => {
          if (!result) throw "invalid form";
        })
        .then(() => this.sendResponse())
        .then(() => this.sent = true)
        .catch(err => {
          this.sending = false;
          console.error(err);
        });
    },
    sendResponse() {
      const url = `${API_URL}/contact`;
      return this.$http.post(url, this.model);
    }
  },
  created() {
    this.$validator.updateDictionary({
      pt: {
        messages: portuguese.messages,
        attributes: {
          email: "E-mail",
          name: "Nome",
          message: "Mensagem"
        }
      }
    });
    this.$validator.setLocale("pt");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input,
select {
  padding: 0.6em 1em;
  font-size: 1.1em;
}

select {
  height: auto !important;
}

.btn-luna {
  padding: 4px 32px;
  border: 4px solid #ffffff;
  border-radius: 999px;
  font-size: 1.2em;
  font-family: "SC Gum Kids";
  text-transform: uppercase;
  color: #fff;
  background-color: #fdb01e;
  box-shadow: inset 0 3px 3px rgb(255, 229, 88),
    inset 0 -3px 3px rgb(232, 137, 17);
}

.btn-luna:hover,
.btn-luna:focus,
.btn-luna:active {
  box-shadow: inset 0 3px 3px rgb(232, 137, 17),
    inset 0 -3px 3px rgb(255, 229, 88);
}

.has-danger .form-control-feedback {
  color: rgb(255, 229, 88);
}

.radio-inline {
  position: relative;
  font-size: 1.2rem;
  display: inline-block;
  position: relative;
  padding-left: 1em;
}

.radio-inline + .radio-inline {
  margin-left: 1em;
}

.radio-inline input[type="radio"] {
  opacity: 0;
  position: absolute;
  margin-top: 4px \9;
  margin-left: -20px;
}

.radio-inline label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 0.74em;
  height: 0.74em;
  top: 0;
  left: 0;
  margin-top: 0.3em;
  border-radius: 50%;
  background-color: #fff;
}

.radio-inline label::after {
  display: inline-block;
  position: absolute;
  content: " ";
  width: 0.48em;
  height: 0.48em;
  left: 0.12em;
  top: 0.12em;
  margin-top: 0.3em;
  border-radius: 50%;
  background-color: #555555;
  transform: scale(0, 0);
  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
}

.radio-inline input[type="radio"]:checked + label::after {
  transform: scale(1, 1);
}

</style>



// WEBPACK FOOTER //
// Contact.vue?0ca5e9f9